'use strict';

(function () {
  'use strict';

  angular.module('msProfile').component('optOuts', {
    bindings: {},
    templateUrl: 'profile/pages/optOuts.html',
    controller: ['$q', '$log', 'activitySvc', 'userSvc', 'NotifyingSvc', 'MetadataSvc', function ($q, $log, activitySvc, userSvc, NotifyingSvc, MetadataSvc) {
      var vm = this;
      // Public Functions
      vm.toggleCategory = _toggleCategory;
      vm.toggleReligion = _toggleReligion;
      /// Controller initialization
      _init();
      //////////////////////////////////////

      function _toggleCategory(tagName) {
        var matchingTag = _.find(vm.youthTags, function (t) {
          return t.shortName === tagName;
        });

        vm.checkboxModel[tagName] = !vm.checkboxModel[tagName];
        if (_emptyCheck()) {
          vm.checkboxModel[tagName] = !vm.checkboxModel[tagName];
          // You have to have at least one option selected.
          return;
        }

        var pref = {};
        pref[matchingTag.shortName] = vm.checkboxModel[tagName];
        _saveOptIn(pref);
      }

      /**
       * validate that there is always at least one tag selected in Youth settings.
       * @returns {boolean}
       * @private
       */
      function _emptyCheck() {
        return !_.some(vm.checkboxModel, function (elem) {
          return elem;
        });
      }

      function _toggleReligion(tagName) {
        var matchingTag = _.find(vm.spiritualTags, function (t) {
          return t.shortName === tagName;
        });
        vm.checkboxModel[tagName] = !vm.checkboxModel[tagName];
        if (_emptyCheck()) {
          vm.checkboxModel[tagName] = !vm.checkboxModel[tagName];
        }

        var pref = {};
        pref[matchingTag.shortName] = vm.checkboxModel[tagName];
        _saveOptIn(pref);
      }

      function _saveOptIn(pref) {
        MetadataSvc.updateProfileComponents(pref, true);
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPTIN_UPDATE);
      }

      function sortYouthTagsData(youthTagsData) {
        // Remove tags that don't have enough activities to show up on the Activities page
        youthTagsData = _.filter(youthTagsData, function (tag) {
          return tag.activities.length >= 5;
        });
        // Group tags based on names.
        vm.mindfulnessCategories = _.filter(youthTagsData, function (item) {
          return _.startsWith(item.shortName, 'youth:mindfulness_');
        });
        vm.schoolCategories = _.filter(youthTagsData, function (item) {
          return (/^youth:(exams|college)$/.exec(item.shortName)
          );
        });
        vm.moodCategories = _.filter(youthTagsData, function (item) {
          return (/^youth:(happiness|humor|depression|stress)$/.exec(item.shortName)
          );
        });
        vm.cultureCategories = _.filter(youthTagsData, function (item) {
          return (/^youth:(music|stigma|fromtheweb)$/.exec(item.shortName)
          );
        });
        // Anything that isn't grouped gets added ot the list
        vm.categories = _.difference(youthTagsData, vm.mindfulnessCategories, vm.religiousCategories, vm.moodCategories, vm.schoolCategories, vm.cultureCategories);
      }

      function _init() {
        vm.categories = [];
        vm.checkboxModel = {};
        $q.all([_fetchProfileComponents(), activitySvc.getAvailableYouthCategoryTags(), activitySvc.getSpiritualTags()]).then(function (data) {
          sortYouthTagsData(data[1]);
          vm.optInTags = data[0];
          vm.youthTags = data[1];
          vm.spiritualTags = data[2];
          vm.religiousCategories = vm.spiritualTags;
          // Set current opt ins to true
          _.each(vm.optInTags, function (t) {
            if (_.find(vm.youthTags, { shortName: t.shortName }) || _.find(vm.spiritualTags, { shortName: t.shortName })) {
              vm.checkboxModel[t.shortName] = true;
            }
          });
        });
      }

      function _fetchProfileComponents() {
        return MetadataSvc.fetchProfileComponents(true).then(function (resp) {
          var resultList = [];
          resp.map(function (d) {
            return resultList = resultList.concat(d.tagList);
          });
          return resultList;
        });
      }
    }]
  });
})();